export const USER_ROLE = {
    KEPALA_UNIT: 'Kepala Unit',
    AREA_MANAGER: 'Area Manager',
}